import { Label } from '@repo/ui'
import { observer } from 'mobx-react-lite'
import React from 'react'
import styled from 'styled-components'

import { ColumnLabelStyled } from '@/components/Playlist'

import { useGameContext } from '../../context/game-context'

export const CurrentColumnName = observer(({ className }: { className?: string }) => {
  const { currentColumnName } = useGameContext()

  return (
    <div className={className}>
      <Label className='justify-center'>Current Column</Label>
      <ColumnLabel>{currentColumnName}</ColumnLabel>
    </div>
  )
})

export const ColumnLabel = styled(ColumnLabelStyled)`
  position: relative;
  background: var(--orange-500);
  color: #181818;
  padding: 0.5em;
  font-size: 2em;
  margin: 0.1em auto 0;
  max-width: 120px;
`
